module.exports = __webpack_public_path__ + "img/inform-risk-2.6a2e9dcb.png";